import { all, takeLatest, put, call, fork } from 'redux-saga/effects';

import {
    partsSelectActions,
    fetchArrowModelAction,
    setPartsSelectAction,
    newDesignAction,
    fetchInitProductSetItemAction,
} from '@app/react/action';
import { fetchCartItemAction } from '@app/react/action/fetchCartItem';

import { getPathParams } from '@app/react/common/getPathParams';
import { KintekiOrdermadeArrowModel } from '@app/react/3d/kintekiOrdermadeArrowModel';
import { EntekiOrdermadeArrowModel } from '@app/react/3d/entekiOrdermadeArrowModel';
import { MakiwaraOrdermadeArrowModel } from '@app/react/3d/makiwaraOrdermadeArrowModel';
import {
    shaftFetchAndApply,
    haneFetchAndApply,
    threadFetchAndApply,
    kebikiFetchAndApply,
    nockFetchAndApply,
    arrowheadFetchAndApply,
    twineFetchAndApply,
    lameFetchAndApply,
    familycrestFetchAndApply,
    familycrestColorFetchAndApply,
    carvingColorFetchAndApply,
    carvingFetchAndApply,
    decorationFetchAndApply,
    featherinsideFetchAndApply,
    threadGloss,
    resetMaterial,
    changeThreadMode,
} from './threejsTask';
import {
    loadKintekiModel,
    loadEntekiModel,
    loadMakiwaraModel,
} from './threejsTask/loadModel';

function* initializeTextureFlow() {
    yield all([
        call(shaftFetchAndApply),
        call(haneFetchAndApply),
        call(threadFetchAndApply),
        call(kebikiFetchAndApply),
        call(nockFetchAndApply),
        call(arrowheadFetchAndApply),
        call(twineFetchAndApply),
        call(lameFetchAndApply),
        call(familycrestFetchAndApply),
        call(familycrestColorFetchAndApply),
        call(carvingFetchAndApply),
        call(carvingColorFetchAndApply),
        call(decorationFetchAndApply),
        call(featherinsideFetchAndApply),
        call(changeThreadMode),
    ]);
}

function* firstFetchArrowModelDataFlow() {
    console.log('[saga] firstFetchArrowModelDataFlow');

    try {
        const [kinteki, enteki, makiwara]: [
            KintekiOrdermadeArrowModel,
            EntekiOrdermadeArrowModel,
            MakiwaraOrdermadeArrowModel,
        ] = yield all([
            call(loadKintekiModel),
            call(loadEntekiModel),
            call(loadMakiwaraModel),
        ]);

        yield put(fetchArrowModelAction({ kinteki, enteki, makiwara }));

        const params = getPathParams();
        if (params !== null) {
            yield call(initializeTextureFlow);
        }
    } catch (error) {
        console.error('[saga] error', error);
    }
}

function* allChangeTextureFlow() {
    yield all([
        call(shaftFetchAndApply),
        call(haneFetchAndApply),
        call(threadFetchAndApply),
        call(kebikiFetchAndApply),
        call(nockFetchAndApply),
        call(arrowheadFetchAndApply),
        call(twineFetchAndApply),
        call(lameFetchAndApply),
        call(familycrestFetchAndApply),
        call(familycrestColorFetchAndApply),
        call(carvingFetchAndApply),
        call(decorationFetchAndApply),
        call(featherinsideFetchAndApply),
        call(changeThreadMode),
    ]);
}

function* shaftAndResetArrowHeadNock() {
    yield fork(shaftFetchAndApply);
    yield fork(arrowheadFetchAndApply);
    yield fork(nockFetchAndApply);
}

function* featherAndReset() {
    yield fork(haneFetchAndApply);
    yield fork(familycrestFetchAndApply);
    yield fork(familycrestColorFetchAndApply);
}

function* featherAndResetWithMakiwara() {
    yield fork(haneFetchAndApply);
    yield fork(featherinsideFetchAndApply);
}

export const arrowModelSaga = [
    fork(firstFetchArrowModelDataFlow),
    takeLatest(partsSelectActions.shaft.started.type, shaftFetchAndApply),
    takeLatest(partsSelectActions.confirmShaft.started.type, shaftAndResetArrowHeadNock),
    takeLatest(partsSelectActions.feather.started.type, haneFetchAndApply),
    takeLatest(partsSelectActions.confirmFeather.started.type, featherAndReset),
    takeLatest(partsSelectActions.confirmFeatherWithMakiwara.started.type, featherAndResetWithMakiwara),
    takeLatest(partsSelectActions.thread.started.type, threadFetchAndApply),
    takeLatest(partsSelectActions.kebiki.started.type, kebikiFetchAndApply),
    takeLatest(partsSelectActions.nock.started.type, nockFetchAndApply),
    takeLatest(partsSelectActions.arrowhead.started.type, arrowheadFetchAndApply),
    takeLatest(partsSelectActions.twine.started.type, twineFetchAndApply),
    takeLatest(partsSelectActions.lame.started.type, lameFetchAndApply),
    takeLatest(partsSelectActions.familycrest.started.type, familycrestFetchAndApply),
    takeLatest(partsSelectActions.fafamilycrestColor.started.type, familycrestColorFetchAndApply),
    takeLatest(partsSelectActions.carving.started.type, carvingFetchAndApply),
    takeLatest(partsSelectActions.decoration.started.type, decorationFetchAndApply),
    takeLatest(partsSelectActions.featherinside.started.type, featherinsideFetchAndApply),
    takeLatest(partsSelectActions.threadGloss.type, threadGloss),
    takeLatest(partsSelectActions.threadMode.type, changeThreadMode),
    takeLatest(setPartsSelectAction.done.type, allChangeTextureFlow),
    takeLatest(newDesignAction.type, resetMaterial),
    takeLatest(fetchCartItemAction.done.type, allChangeTextureFlow),
    takeLatest(fetchInitProductSetItemAction.done.type, allChangeTextureFlow),
];
